import { Button } from "@material-ui/core";
import { useMutation, useNotify } from "react-admin";
import { memo } from "react";
import { makeStyles } from "@material-ui/core/styles";

interface IFindInvoiceButton {
  formData: any;
  setInvoiceInfoData?: any;
}

const useStyles = makeStyles({
  root: {
    marginLeft: 0,
  },
});

const FindInvoiceButton = ({
  formData,
  setInvoiceInfoData,
}: IFindInvoiceButton) => {
  const notify = useNotify();
  const classes = useStyles();

  const isFilled: boolean = formData.documentNumber
    ? formData.documentNumber !== ""
    : false;

  const [HandleFindInvoice, { loading }] = useMutation(
    {
      type: "customGetOne",
      resource: `accounting/checkOwner/${formData.documentNumber}`,
      payload: {
        data: {},
      },
    },
    {
      onSuccess: ({ data }) => {
        setInvoiceInfoData(data);
      },
      onFailure: (error) => {
        setInvoiceInfoData();
        notify(`Failed Find Invoice Info, error: ${error.message}`, "warning");
      },
    }
  );

  return (
    <Button
      className={classes.root}
      variant="contained"
      color="primary"
      onClick={HandleFindInvoice}
      disabled={!isFilled}
    >
      {loading ? "Loading..." : "FIND"}
    </Button>
  );
};
export default memo(FindInvoiceButton);
